'use client'

import { BuilderBlocks } from '@builder.io/react'
import { RadioGroup } from '@headlessui/react'
import { useState } from 'react'

import { Button } from '@src/components/Button/Button'
import { useLoadings } from '@src/hooks/useLoadings'
import { useBreakpoints } from '@src/utils/breakpoints.util'

import type { SKUSelectorProps } from './SKUSelectorProps'
import { SKUSelectorRadio } from './SKUSelectorRadio'

export function SKUSelector(props: SKUSelectorProps) {
  const firstOption = props.options?.[0]
  const firstDropdownOption = firstOption?.dropdownOptions?.[0]
  const [selectedSku, setSelectedSku] = useState(firstDropdownOption?.sku ?? firstOption?.sku ?? '')
  const isLoading = useLoadings().loadings.isAddingLineItems ?? false
  const breakpoints = useBreakpoints()
  const isMobile = breakpoints.isMobile || breakpoints.isTablet

  return (
    <div data-testid="sku-selector">
      <RadioGroup
        className="relative flex shrink-0 flex-col gap-2"
        value={selectedSku}
        onChange={(sku) => sku && !isLoading && setSelectedSku(sku)}
      >
        {props.options.map((option, index) => (
          <SKUSelectorRadio
            key={`${index}-${JSON.stringify(option)}`}
            index={index}
            option={option}
            selectedSku={selectedSku}
            isLoading={isLoading}
            previewAllItems={props.previewAllItems}
            builderBlock={props.builderBlock}
            onChange={(sku) => setSelectedSku(sku)}
          />
        ))}
      </RadioGroup>
      <Button
        className="mt-4 w-full"
        isLoading={isLoading}
        variant={props.addToCartVariant ?? 'primary'}
        size={isMobile ? 'medium' : 'large'}
        actionName="addItemsToCart"
        addItemsToCart={{
          skus: [{ sku: selectedSku, quantity: 1 }],
          redirectUrl: props.redirectUrl,
        }}
      >
        <BuilderBlocks
          blocks={props.addToCartContent}
          parentElementId={props.builderBlock?.id}
          dataPath={`component.addToCartContent`}
        />
      </Button>
    </div>
  )
}
